import React, { Component, Fragment } from "react";

import { default as UserDetailsCard } from "./components/UserDetailsCard.js";
import { default as UserActions } from "../ProfilePage/components/UserActions.jsx";

class UserViewPage extends Component {
  componentDidMount() {
    this.props.fetchUser(this.props.match.params.id);
  }

  render() {
    let { isLoading } = this.props;
    return (
      <Fragment>
        {isLoading ? (
          <Fragment />
        ) : (
          <div className="row">
            <div className="col-sm-12 col-md-4 p-1">
              <UserDetailsCard />
            </div>
            <div className="col-sm-12 col-md-8 p-1">
              <UserActions userId={this.props.match.params.id} />
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default UserViewPage;
